// extracted by mini-css-extract-plugin
export default {"container":"_2CSwHtJD-OacZP08on_fVq","info":"_1DFBXcjU21t0B7P3IpdfvJ"};